// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { ErrorHandler, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { SentryErrorHandler } from './sentry.error-handler';
import {
  ProjectsService,
  FlagsService,
  FlagsGuardService,
  LoggerService,
  // SentryService,
  AuthGuardService,
  AuthService,
  UserService,
  ContractService,
  MembershipsService,
  PermissionsGuardService,
  RolesService,
  PolicyService,
  OrganizationService
} from '@app/core/services';
import { AuthHttpInterceptor } from './auth-http-interceptor';
import { InputTextValidatorService } from './services/input-text-validator.service';
import { AlertService } from './services/alert.service';
import { LoggedUserFacadeService } from './state/logged-user/logged-user.facade';
import { LoggedUserService } from './services/logged-user.service';
import { HttpService } from './services/http.service';

/**
 * CoreModule is where all singleton services should be shared/provided.
 */
@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [
    FlagsService,
    LoggerService,
    // SentryService,
    AuthService,
    AuthGuardService,
    FlagsGuardService,
    ProjectsService,
    UserService,
    ContractService,
    MembershipsService,
    PermissionsGuardService,
    RolesService,
    PolicyService,
    InputTextValidatorService,
    AlertService,
    LoggedUserFacadeService,
    LoggedUserService,
    OrganizationService,
    HttpService,
    // { provide: ErrorHandler, useClass: SentryErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true }
  ]
})
export class CoreModule {}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts